import { Flex, Text, Box, Image } from "rebass/styled-components";

interface Props {
  title?: string;
  children: any;
  imgsrc: string;
  imgAlt?: string;
  imgRight?: boolean;
  imgLeft?: boolean;
  bgColor?: string;
  color?: string;
  showImgMobile?: boolean;
  height?: any;
}

function TextWithImg(props: Props) {
  const {
    title,
    children,
    imgsrc,
    imgAlt,
    imgRight,
    imgLeft,
    bgColor = "inuOrange",
    color = "samoyedWhite",
    showImgMobile = true,
    height
  } = props;

  return (
    <Flex
      variant={"textWithImg.flex"}
      sx={{ backgroundColor: bgColor, color: color, height: height }}
    >
      {imgRight || (imgRight === imgLeft) === undefined ? (
        <>
          <Box variant={"textWithImg.boxTextLeft"}>
            {title && (
              <Text as="h2" variant={"textWithImg.title"}>
                {title}
              </Text>
            )}
            {children}
          </Box>
          <Box
            variant={"textWithImg.boxImg"}
            sx={!showImgMobile && { display: ["none", "none", "inherit"] }}
          >
            <Box height={"100%"}>
              <Image
                variant={"textWithImg.img"}
                src={imgsrc}
                alt={imgAlt || title}
              />
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Box
            variant={"textWithImg.boxImg"}
            sx={!showImgMobile && { display: ["none", "none", "inherit"] }}
          >
            <Box height="100%" width="100%">
              <Image
                variant={"textWithImg.img"}
                src={imgsrc}
                alt={imgAlt || title}
              />
            </Box>
          </Box>
          <Box variant={"textWithImg.boxTextRight"}>
            {title && (
              <Text as="h2" variant={"textWithImg.title"}>
                {title}
              </Text>
            )}
            {children}
          </Box>
        </>
      )}
    </Flex>
  );
}

export default TextWithImg;
